import type { ProductWithHelpers } from '@shared/products-core';

type UnderlyingProduct = any;

export function getUnderlyingProduct(product: ProductWithHelpers): UnderlyingProduct | undefined {
    if (product.underlyingData) {
        return product.underlyingData;
    }

    if (product.underlyingCard) {
        return product.underlyingCard;
    }

    return undefined;
}

export function getUnderlyingProductId(product: ProductWithHelpers): string | undefined {
    return getUnderlyingProduct(product)?.id;
}

export function getUnderlyingProductI18n(product: ProductWithHelpers): string | undefined {
    return getUnderlyingProduct(product)?.productI18N;
}
